import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

const InstructionSteps = ({ steps }) => {
  const { t } = useLanguage();
  const rd = t.recipeDetail;

  if (!steps || !steps.length) {
    return (
      <section className="recipe-instructions">
        <h3>{rd.methodTitle}</h3>
        <p className="empty-copy">{rd.methodFallback}</p>
      </section>
    );
  }

  return (
    <section className="recipe-instructions">
      <h3>{rd.methodTitle}</h3>
      <ol>
        {steps.map((step, index) => (
          <li key={`${step.instruction || 'step'}-${index.toString()}`}>
            <div className="step-number">{index + 1}</div>
            <div className="step-content">
              <p>{step.instruction || 'Instruction coming soon.'}</p>
              {step.healthyAlternatives?.length ? (
                <p className="step-alt">
                  <span>{rd.healthyAlt}</span> {step.healthyAlternatives.join(', ')}
                </p>
              ) : null}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default InstructionSteps;
